<div
  class="d-flex align-items-center"
  [ngClass]="{
    'invalid-feedback': type === Type.ERROR,
    'text-primary': type === Type.INFO,
    'mb-3': header,
    'fs-7': !header
  }"
>
    <span *ngIf="showIcon"
      class="svg-icon svg-icon-2x svg-icon-danger cursor-pointer me-4"
      [ngbTooltip]="message"
      [inlineSVG]="ICONS.ICON_ERROR"
    ></span>
    {{ message }}
</div>
